import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Tag } from 'mojo-tag';
import { Observable } from 'rxjs';

import { Location } from '@shared/models';

import { ApiService } from './api.service';

@Injectable()
export class GeolocationService extends ApiService<Tag> {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'geolocation/locations';
  }

  autocomplete(name: string): Observable<Location[]> {
    return super.get({ params: { name } });
  }
}
